<div class="title">
    <mat-icon *ngIf="icon.length > 0">{{icon}}</mat-icon>
    <h1 mat-dialog-title class="margin">{{data.title}}</h1>
</div>

<div mat-dialog-content>
    <div class="radio" *ngIf="data.public">
        <div class="row-radio">
            <mat-icon class="icon" *ngIf="isTheme === 'light'">wb_sunny</mat-icon>
            <mat-icon class="icon" *ngIf="isTheme !== 'light'">brightness_3</mat-icon>
            <span class="theme">{{"dashboard.share.theme" | translate}} :</span>
            <mat-radio-group aria-label="Select theme" [(ngModel)]="isTheme" (change)="updateUrl()">
                <mat-radio-button value="light" class="space-radio">{{"dashboard.share.light" |
                    translate}}</mat-radio-button>
                <mat-radio-button value="dark">{{"dashboard.share.dark" | translate}}</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="row-radio" *ngIf="!noFilter">
            <mat-icon class="icon">filter_list</mat-icon>
            <span class="theme">{{"editor.filter" | translate}} :</span>
            <mat-radio-group aria-label="Select filter" [(ngModel)]="isFilter" (change)="updateUrl()">
                <mat-radio-button value="false" class="space-radio">{{"dashboard.share.without" |
                    translate}}</mat-radio-button>
                <mat-radio-button value="true">{{"dashboard.share.with" | translate}}</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

    <mat-form-field class="input-width" appearance="outline">
        <mat-label *ngIf="data.public">{{"dashboard.share.url_public" | translate}}</mat-label>
        <mat-label *ngIf="!data.public">{{"dashboard.share.url_report" | translate}}</mat-label>
        <input matInput [(ngModel)]="data.url" readonly>
    </mat-form-field>

    <button mat-icon-button color="primary" (click)="copy()"><mat-icon>file_copy</mat-icon></button>
    <button mat-icon-button color="secondary" (click)="open()"><mat-icon>open_in_new</mat-icon></button>

</div>
<div mat-dialog-actions class="btn-actions">
    <button mat-flat-button color="primary" (click)="ok()">Ok</button>
</div>